/* NESTORA - product cards on collection/search/related grids.

   Two jobs, both done in JS because snippets/card-product.liquid is 35KB and
   the Admin API has no partial edit for theme files:

   1. Replace Dawn's "Choose options" quick-add with a single "Buy Now" button
      that opens the full product page.
   2. Move the price and that button into one footer row, so the card reads
      price-left / button-right like the rest of the store. */
(function () {
  var LABEL = 'Buy Now';
  var busy = false;

  function productUrl(scope) {
    if (!scope) return null;
    var link = scope.querySelector('.card__heading a[href], a.card__link[href], a[href*="/products/"]');
    return link ? link.getAttribute('href') : null;
  }

  function convert(box) {
    if (box.hasAttribute('data-nst-buynow')) return;
    box.setAttribute('data-nst-buynow', '');

    var card = box.closest('.card-wrapper') || box.closest('.grid__item') || box.parentElement;
    var url = productUrl(card);
    if (!url) return;

    var link = document.createElement('a');
    link.className = 'button button--full-width nst-buynow';
    link.href = url.split('?')[0];
    link.textContent = LABEL;

    box.classList.remove('no-js-hidden');
    box.innerHTML = '';
    box.appendChild(link);
  }

  /* Price and button start in separate blocks; put them on one line. */
  function buildFoot(content) {
    if (content.hasAttribute('data-nst-foot')) return;

    var price = content.querySelector('.price');
    var quick = content.querySelector('.quick-add');
    if (!price && !quick) return;

    content.setAttribute('data-nst-foot', '');

    var foot = document.createElement('div');
    foot.className = 'nst-foot';
    if (price) foot.appendChild(price);
    if (quick) foot.appendChild(quick);
    content.appendChild(foot);

    /* the wrapper the price came out of is usually left empty */
    var info = content.querySelector('.card-information');
    if (info && !info.querySelector('*')) info.classList.add('nst-empty');
  }

  function run() {
    if (busy) return;
    busy = true;
    try {
      var boxes = document.querySelectorAll('.quick-add');
      for (var i = 0; i < boxes.length; i++) convert(boxes[i]);

      var contents = document.querySelectorAll('.card-wrapper .card__content');
      for (var j = 0; j < contents.length; j++) buildFoot(contents[j]);
    } finally {
      document.documentElement.classList.add('nst-buynow-ready');
      busy = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* collection filters, pagination and search re-render the grid */
  var pending = false;
  var observer = new MutationObserver(function () {
    if (busy || pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      run();
    });
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
